module.exports = __webpack_public_path__ + "img/public/SiteIcons/greatSuccess.svg?04e468e1";